export const ITEM_HEIGHT = 138;
export const ITEM_SPACE_BOTTOM = 12;
export const ACTIVE_ITEM_HEIGHT = 288;
